var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManagers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.93372 7.5199C8.93372 8.04934 8.51466 8.4799 8.00039 8.4799C7.48566 8.4799 7.06706 8.04934 7.06706 7.5199H2.40039V12.0799C2.40039 12.4769 2.71446 12.7999 3.10039 12.7999H12.9004C13.2863 12.7999 13.6004 12.4769 13.6004 12.0799V7.5199H8.93372Z",
    fill: "rgba(255, 255, 255, 0.6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.60039 3.92003C6.60039 3.78755 6.70492 3.68003 6.83372 3.68003H9.16706C9.29539 3.68003 9.40039 3.78755 9.40039 3.92003V4.64003H6.60039V3.92003ZM7.19679 7.03995C7.35872 6.75435 7.65646 6.55995 8.00039 6.55995C8.34432 6.55995 8.64206 6.75435 8.80399 7.03995H13.6004V5.35995C13.6004 4.96299 13.2863 4.63995 12.9004 4.63995H9.86706V3.91995C9.86706 3.52299 9.55299 3.19995 9.16706 3.19995H6.83372C6.44779 3.19995 6.13372 3.52299 6.13372 3.91995V4.63995H3.10039C2.71446 4.63995 2.40039 4.96299 2.40039 5.35995V7.03995H7.19679Z",
    fill: "rgba(255, 255, 255, 0.6)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00182 8.00004C8.25896 8.00004 8.46849 7.78452 8.46849 7.52004C8.46849 7.25556 8.25896 7.04004 8.00182 7.04004C7.74469 7.04004 7.53516 7.25556 7.53516 7.52004C7.53516 7.78452 7.74469 8.00004 8.00182 8.00004Z",
    fill: "rgba(255, 255, 255, 0.6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagers);
export default __webpack_public_path__ + "static/media/managers.436108e9abcb0f3187d12a78ccfe961d.svg";
export { ForwardRef as ReactComponent };